module.exports = __webpack_public_path__ + "school/img/chineseClassicsDetailBg.568e3ba4.jpg";